import React, { Fragment, useState } from 'react';
import { Input, Card, CardBody, Container, Row, Col, Button, FormGroup, Label, List, CardHeader, Collapse, Form } from 'reactstrap';
import Datetime from 'react-datetime';
import 'moment/locale/es';
import Select from 'react-select';
import { useWorkOrderDay } from '../../../hooks/workOrderDay/useWorkOrderDay';
import '../../../hooks/componentMultiSelect/MultiSelectDemo.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import { MultiSelect } from 'primereact/multiselect';
import 'animate.css';
import './styleWorkDay.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { cedimi, pyrsa, semlab, sharp, labcen } from '../../../constant/globalConstantsTypeClients'
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import DeniReactTreeView from "deni-react-treeview"
import { SelectButton } from 'primereact/selectbutton';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Tooltip } from "reactstrap";
import moment from 'moment';
import { Dropdown } from "primereact/dropdown";







export const IndexWorkOrderDay = () => {

    const {
        totalWorkOrderUrgent, totalWorkOrderCritic, totalWorkOrderNormal, totalWorkOrder, sections, changeCheckbox,
        mDateRange1, mDateRange2, mSelectBranch, nim, branches, handleInputChange, handleSelectValues, getWorkOrders, loading, workOrders, handlePickerValues,
        navigateConfigPrices, navigateCaptureResults,
        navigateUpdate,
        selectedSections, sectiondefault, printSticker, printTicket,
        changeFiltersRangeNim, filterRangeNims, getNimsFromRange,
        statusOrder, mSelectStatus,
        resetLocalStorage, printStickerMicro, listExams, mExam,

        //*type service
        mSelectTypeService, dataTypeService,
        expandedRows2, setExpandedRows2, filterType, setFilterType, rowExpansionTemplate2, filteredWorkOrders, exportToExcel,
        renderStatusTag,
        globalFilter2, setGlobalFilter2,
        modalCheckSpecimen, toggleListExamEmail, handleViewExamTree,
        treeviewRef, itemsTree, onRenderItem, loadingSpecimen,
        OptionsCheck, setMatchExact, match_exact,
        dataTraceability, loadingTrazability, handleShowTraceability,
        opTraceability, selectedNim,
        _capture_lock, enable_tracking_toma, _menu,
        getStudyDeliveryToday,
        loadingToday,
        showStudyDelivery,
        getDeliveryStatus,
        showDeliveryFilter, setShowDeliveryFilter







    } = useWorkOrderDay();
    console.log("🚀 ~ IndexWorkOrderDay ~ filteredWorkOrders:", filteredWorkOrders)
    console.log("🚀 ~ IndexWorkOrderDay ~ filteredWorkOrders:", dataTraceability)

    let _validTraceability = enable_tracking_toma === "True" && _capture_lock === "True" ? true : false;

    const [tooltipOpen, setTooltipOpen] = useState("");

    const toggleTooltip = (id) => {
        setTooltipOpen(tooltipOpen === id ? "" : id);
    };

    const [filters, setFilters] = useState(true);
    const [filterDate, setFilterDate] = useState(false);
    const [filtersRangeNim, setFiltersRangeNim] = useState(false);
    let validHopitalInterfaced = localStorage.getItem('interfaced');
    let _url_helen = localStorage.getItem('url_helen');


    // * STYLES DATA TABLE
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
        zIndex: 2
    };



    const txtsection = localStorage.getItem('TextAS');


    const changeFilters = (typeFilter) => {
        switch (typeFilter) {
            case "date":
                setFilters(!filters);
                setFilterDate(false);
                setFiltersRangeNim(false);
                break;
            case "search":
                setFilters(false);
                setFilterDate(!filterDate);
                setFiltersRangeNim(false);

                break;
            case "range":
                setFilters(false);
                setFilterDate(false);
                setFiltersRangeNim(!filtersRangeNim);

                break;
            default:
                break;
        }
    }


    const tagInfo = (rowData) => {
        if (rowData._critical === 2) {
            return <Tag style={{ fontSize: "11px" }} className="mr-2 pointer" severity='danger' value={rowData.nim} onClick={rowData.id_status !== 20 ? () => navigateCaptureResults(rowData.nim) : ''} ></Tag>;
        }
        else if (rowData._urgent === 1) {
            return <Tag className="mr-2 pointer" style={{ fontSize: "11px" }} severity='warning' value={rowData.nim} onClick={rowData.id_status !== 20 ? () => navigateCaptureResults(rowData.nim) : ''}></Tag>;
        }
        return <Tag className="mr-2 pointer" style={{ fontSize: "11px" }} severity='primary' value={rowData.nim} onClick={rowData.id_status !== 20 ? () => navigateCaptureResults(rowData.nim) : ''}></Tag>;
    };

    const getDate = (rowData) => {
        return (
            <div>
                <label className={rowData?.id_status === 20 ? "txt-danger" : 'txt-secondary'}>
                    {rowData.admision_date}
                </label> <br />
                <label
                    className={rowData?.id_status === 20 ? "txt-danger" : 'txt-secondary'}
                    style={{ fontSize: "11px" }}
                >
                    {rowData?.fechAndDate ?? "----"}
                </label>
            </div>
        );
    };


    const getSection = (rowData) => {
        return <div >
            <List type="unstyled"  >
                {
                    rowData.listSections.length >= 1 &&
                    rowData.listSections.map((item, index) => {
                        return (
                            <li className={rowData?.id_status === 20 ? "txt-danger" : ""} key={index}>{item.name_section}</li>
                        )
                    })
                }
            </List>
        </div>
    };

    const getPatient = (rowData) => {
        return <label className={rowData?.id_status === 20 ? "txt-danger" : ''}>  {rowData.is_micro === true ? rowData.company_name : rowData.name_patient}</label>

    };

    const getNameCompany = (rowData) => {

        const companyName = rowData?.company_name
            ? `${rowData.company_name}\n${rowData.contract_number_agreement ?? "----"}`
            : "----";
        const truncatedName = companyName.length > 14 ? companyName.substring(0, 14) + "..." : companyName;

        return (
            <div>
                <label className={rowData?.id_status === 20 ? "txt-danger" : ''}>
                    {rowData.income_type}
                </label>
                <label
                    className={rowData.income_type === "Empresas" ? "" : rowData.income_type === "Publico general" ? "d-none" : rowData?.id_status === 20 ? "txt-danger" : 'txt-secondary'}
                    style={{ fontSize: "11px" }}
                >
                </label> <br />
                <b
                    style={{
                        display: 'inline-block',
                        maxWidth: '200px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        cursor: 'pointer'
                    }}
                    title={companyName}
                >
                    {truncatedName}
                </b>
            </div>
        );
    };

    const getButtonStyle1 = (bgColor) => ({
        width: "26px",
        height: "26px",
        fontSize: "0.65rem",
        borderRadius: "8px",
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        color: "#000",
        cursor: "pointer",
        backgroundColor: bgColor,
    });


    const getButtonStyle = (bgColor) => ({
        width: "26px",
        height: "26px",
        fontSize: "0.65rem",
        borderRadius: "8px",
        padding: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        color: "#fff",
        cursor: "pointer",
        backgroundColor: bgColor,
    });

    const buttonStyle = getButtonStyle("#f97316");
    const buttonStyle5 = getButtonStyle("#002940");
    const buttonStyle6 = getButtonStyle("#000");
    const buttonStyle7 = getButtonStyle1("#ecab0f");
    const buttonStyle8 = getButtonStyle("#0eb735");




    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    const sortByDateTime = (event) => {
        const data = [...event.data];

        const getDateTime = (row) => {
            if (!row.admision_date) return 0;

            const [day, month, year] = row.admision_date.split("/");

            let hours = 0;
            let minutes = 0;

            if (row.fechAndDate) {
                let [time, modifier] = row.fechAndDate.split(" ");
                let [h, m] = time.split(":");

                hours = parseInt(h, 10);
                minutes = parseInt(m, 10);

                if (modifier?.toLowerCase().includes("p") && hours !== 12) {
                    hours += 12;
                }
                if (modifier?.toLowerCase().includes("a") && hours === 12) {
                    hours = 0;
                }
            }

            return new Date(year, month - 1, day, hours, minutes).getTime();
        };

        data.sort((a, b) => {
            const date1 = getDateTime(a);
            const date2 = getDateTime(b);
            return event.order * (date1 - date2);
        });

        event.data = data;
        return data;
    };


    // ? CONFIGURATION FOR LED STATUS



    const getAllExams = (row) => {
        const root =
            row.listExm ||
            row.listExam ||
            [];

        const fromProfiles =
            (row.listProfile || []).flatMap(
                p => p.listExm || p.listExam || []
            );


        return [...root, ...fromProfiles];
    };


    const getLedStatus = (row) => {
        const exams = getAllExams(row);

        if (!exams.length) return "red";

        const completed = exams.filter(e =>
            e.is_send1 === true &&
            e.is_send2 === true
        );

        const hasAnyProgress = exams.some(e =>
            e.is_send1 === true ||
            e.is_send2 === true
        );

        if (completed.length === exams.length) return "green";

        if (hasAnyProgress) return "yellow";

        return "red";
    };

    const getTraceabilityStatus = (row, field) => {

        if (row.type === "exam") {
            return row[field] === true;
        }

        const exams = getAllExams(row);

        if (!exams.length) return false;

        const allOk = exams.every(exam => exam[field] === true);

        return allOk;
    };

    const [deliveryStatusFilter, setDeliveryStatusFilter] = useState(null);

    const statusOptions = [
        { label: "Todos", value: null },
        { label: "Entregado", value: "Entregado" },
        { label: "En tiempo", value: "En tiempo" },
        { label: "Próxima", value: "Próxima" },
        { label: "Urgente", value: "Urgente" },
        { label: "Vencido", value: "Vencido" }
    ];

    const workOrdersFiltered = filteredWorkOrders.filter(item => {
        if (!deliveryStatusFilter) return true;

        return getDeliveryStatus(
            item.study_delivery,
            item.id_status
        ) === deliveryStatusFilter;
    });
    

    

    return (
        <Fragment>
            <div className='container-global-zoom'  >
                <Row>

                    <Col className='default-according style-1 faq-accordion job-accordion position-relative p-t-0 p-b-0' id="accordionoc" xs="12" sm="6" md="6" lg="3" xl="3"  >
                        <Row className="position-sticky" style={{ top: 73 }}>
                            <Col xl="12">
                                <Card>
                                    <CardHeader className='bg-secondary'>
                                        <h5 className="mb-0">
                                            <Button color="link pl-0" data-toggle="collapse" onClick={() => changeFilters("date")}
                                                data-target="#collapseicon" aria-expanded={filters} aria-controls="collapseicon"><i className="fa fa-filter fIconFilter"></i> &nbsp; &nbsp; &nbsp; &nbsp;<label className='labelFilter'>Filtros de busqueda</label></Button>
                                        </h5>
                                    </CardHeader>
                                    <Collapse isOpen={filters}>
                                        <CardBody className="p-2 p-t-0">
                                            <Form onSubmit={(e) => getWorkOrders(e, false, true)}>
                                                <Row>
                                                    <Col md="12" className="p-initial">
                                                        <Label className="labelFilter">Fecha de admisión</Label>
                                                        <Row className="m-0">
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="6" className='p-l-0 '>
                                                                <FormGroup className="labelFilter">
                                                                    <Datetime
                                                                        inputProps={{
                                                                            placeholder: 'YYYY-MM-DD',
                                                                            name: "workFrom",
                                                                            autoComplete: "false",
                                                                            className: "form-control digits input-air-primary form-control-sm ",
                                                                        }}
                                                                        timeFormat={false}
                                                                        // dateFormat="YYYY-MM-DD"
                                                                        value={mDateRange1}
                                                                        locale="es"
                                                                        initialValue={new Date()}
                                                                        onChange={(e) => handlePickerValues(e, "mDateRange1")}
                                                                        closeOnSelect={true}

                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col xs="12" sm="12" md="12" lg="12" xl="6" className='p-l-0 '>
                                                                <FormGroup >
                                                                    <Datetime
                                                                        inputProps={{
                                                                            placeholder: 'YYYY-MM-DD',
                                                                            name: "workFrom",
                                                                            autoComplete: "false",
                                                                            className: "form-control digits input-air-primary form-control-sm ",
                                                                            size: "sm"
                                                                        }}
                                                                        timeFormat={false}
                                                                        // dateFormat={"YYYY-MM-DD"}
                                                                        locale="es"
                                                                        value={mDateRange2}
                                                                        initialValue={new Date()}
                                                                        onChange={(e) => handlePickerValues(e, "mDateRange2")}
                                                                        closeOnSelect={true}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            {/* no mover este imput por la clase que lleva para que sea visible y tranparente en las cards*/}
                                                            <Datetime
                                                                inputProps={{
                                                                    placeholder: 'YYYY-MM-DD',
                                                                    name: "workFrom",
                                                                    autoComplete: "false",
                                                                    className: "form-control digits input-air-primary form-control-sm ",
                                                                    size: "sm"
                                                                }}
                                                                timeFormat={false}
                                                                dateFormat={"YYYY-MM-DD"}
                                                                locale="es"
                                                                initialValue={new Date()}
                                                                closeOnSelect={true}
                                                                className="rdtPicker"
                                                            />
                                                        </Row>
                                                    </Col>
                                                    {
                                                        validHopitalInterfaced === "True" && <Col sm="12" md="12" lg="12">
                                                            <FormGroup>
                                                                <Label className='col-form-label'>Tipo de servicio</Label>
                                                                <Select
                                                                    name="mSelectTypeService"
                                                                    value={mSelectTypeService}
                                                                    isClearable={true}
                                                                    placeholder="Selecciona una opción"
                                                                    options={dataTypeService}
                                                                    className="input-air-primary input-sm"
                                                                    onChange={(e) => handleSelectValues(e, "mSelectTypeService")}
                                                                   

                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    }
                                                    <Col className="m-0">
                                                        <Label className=" labelFilter">Secciones</Label>
                                                         <MultiSelect
                                                            className="basic-multi-select input-air-primary form-control-sm"
                                                            value={selectedSections}
                                                            options={sectiondefault}
                                                            onChange={(e) => changeCheckbox(e.value)}
                                                            optionLabel="name"
                                                            placeholder={`Selecciona una ${txtsection}`}
                                                            maxSelectedLabels={3}
                                                            selectedItemsLabel="Secciones Agregadas"
                                                            // appendTo={document.body}
                                                            appendTo="self"
                                                        />

                                                    </Col>
                                                    <Col sm="12" md="12" lg="12">
                                                        <FormGroup>
                                                            <Label className='col-form-label'>Exámanes</Label>
                                                            <Select
                                                                name="mExam"
                                                                value={mExam}
                                                                isClearable={true}
                                                                placeholder="Selecciona una opción"
                                                                options={listExams}
                                                                className="input-air-primary input-sm"
                                                                onChange={(e) => handleSelectValues(e, "mExam")}
                                                            />
                                                        </FormGroup>
                                                    </Col>

                                                    <Col md="12 m-0">
                                                        <Label className="labelFilter ">Sucursales<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                                        <FormGroup>
                                                            <Select
                                                                name="mSelectBranch"
                                                                isClearable={true}
                                                                placeholder="Selecciona una sucursal"
                                                                noOptionsMessage={() => "Sin resultados"}
                                                                options={branches}
                                                                onChange={(e) => handleSelectValues(e, 'mSelectBranch')}
                                                                value={mSelectBranch}

                                                            />
                                                        </FormGroup>
                                                    </Col>


                                                    <Col sm="12" md="12" lg="12">
                                                        <Label className="labelFilter ">Estatus</Label>
                                                        <Select
                                                            name="mSelectStatus"
                                                            isClearable={true}
                                                            placeholder="Selecciona un estatus"
                                                            noOptionsMessage="Sin resultados"
                                                            options={statusOrder}
                                                            onChange={(e) => handleSelectValues(e, 'mSelectStatus')}
                                                            value={mSelectStatus}
                                                            className="b-r-9"

                                                        />
                                                    </Col>
                                                    <Col>

                                                    </Col>
                                                    <Col md="12">
                                                        <Button
                                                            type="submit"
                                                            outline
                                                            color="primary"
                                                            onClick={(e) => getWorkOrders(e, false, true, "Filtrar")}
                                                            className={loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1"}
                                                        >
                                                            Filtrar
                                                        </Button>
                                                        <Button type="button" onClick={resetLocalStorage} outline color='danger' className={(loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1")}>
                                                            Restablecer
                                                        </Button>
                                                        <Button
                                                            type="submit"
                                                            outline
                                                            color="success"
                                                            onClick={(e) => getWorkOrders(e, false, true, "Interfazados")}
                                                            className={loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1"}
                                                        >
                                                            Interfazados
                                                        </Button>

                                                    </Col>
                                                </Row>
                                            </Form>
                                        </CardBody>
                                    </Collapse>
                                </Card>
                                <Card>
                                    <CardHeader className='bg-secondary'>
                                        <h5 className="mb-0">
                                            <Button color="link pl-0" data-toggle="collapse" onClick={() => changeFilters("range")}
                                                data-target="#collapseicon" aria-expanded={filtersRangeNim} aria-controls="collapseicon"><i className="fa fa-filter fIconFilter"></i>&nbsp; &nbsp; &nbsp; &nbsp; <label className='labelNim'>Filtro de rango de nims</label>   </Button>
                                        </h5>
                                    </CardHeader>
                                    <Collapse isOpen={filtersRangeNim}>
                                        <CardBody className="p-3">
                                            <Row>
                                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <label className='labelIndications' >Fecha de admisión<span className='f-16' style={{ color: "#0079C7" }}>*</span></label>
                                                    <FormGroup className="">
                                                        <Datetime
                                                            inputProps={{
                                                                placeholder: 'YYYY-MM-DD',
                                                                name: "workFrom",
                                                                autoComplete: "false",
                                                                className: "form-control digits input-air-primary form-control",
                                                            }}
                                                            timeFormat={false}
                                                            dateFormat="YYYY-MM-DD"
                                                            // value={mDateRange1}
                                                            locale="es"
                                                            initialValue={new Date()}
                                                            onChange={(e) => changeFiltersRangeNim(e, "date_range_nim")}
                                                            closeOnSelect={true}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                                                    <Label className="labelFilter">Sucursal<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                                    <FormGroup>
                                                        <Select
                                                            name="mSelectBranch"
                                                            isClearable={true}
                                                            placeholder="Selecciona una sucursal"
                                                            noOptionsMessage="Sin resultados"
                                                            options={branches}
                                                            onChange={(e) => changeFiltersRangeNim(e, 'branch_range_nim')}
                                                        // value={mSelectBranch}

                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" sm="12" md="12" lg="12" xl="6">
                                                    <Label className="labelFilter">Inicio<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                                    <FormGroup>
                                                        <Input type='number' className='form-control form-control-sm input-air-primary'
                                                            name="init_range_nim"
                                                            // value={nim}
                                                            onChange={(e) => changeFiltersRangeNim(e.target.value, "init_range_nim")} />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="12" sm="12" md="12" lg="12" xl="6">
                                                    <Label className="labelFilter">Fin<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                                                    <FormGroup>
                                                        <Input type='number' className='form-control form-control-sm input-air-primary'
                                                            name="end_range_nim"
                                                            // value={nim}
                                                            onChange={(e) => changeFiltersRangeNim(e.target.value, "end_range_nim")} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="12">
                                                    <Button type="button" onClick={getNimsFromRange} outline color="primary" className={(loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1")} > Buscar</Button>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Collapse>
                                </Card>
                                <Card className={(_url_helen === cedimi || _url_helen === pyrsa || _url_helen === semlab || _url_helen === sharp) ? "" : "d-none"}  >
                                    <CardHeader className='bg-secondary'>
                                        <h5 className="mb-0">
                                            <Button color="link pl-0" data-toggle="collapse" onClick={() => changeFilters("search")}
                                                data-target="#collapseicon" aria-expanded={filterDate} aria-controls="collapseicon"><i className="icon-search fIcon"></i>&nbsp; &nbsp; &nbsp; &nbsp; <label className='labelNim'>Busqueda por NIM o Nombre</label>   </Button>
                                        </h5>
                                    </CardHeader>
                                    <Collapse isOpen={filterDate}>
                                        <CardBody className="p-3">
                                            <Form onSubmit={(e) => getWorkOrders(e, true)}>
                                                <Row>
                                                    <Col md="12 m-0">
                                                        <FormGroup className="col-md-12">
                                                            <Label className="col-form-label">Ingresa el NIM  o Nombre a buscar<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>

                                                            <Input className='form-control form-control-sm input-air-primary' name="nim" value={nim} onChange={handleInputChange} />
                                                        </FormGroup>
                                                        <Col md="12">
                                                            <Button type="submit" outline color="primary" className={(loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1")} > Buscar</Button>
                                                        </Col>
                                                    </Col>

                                                </Row>
                                            </Form>
                                        </CardBody>
                                    </Collapse>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs="12" sm="9" md="9" lg="9" xl="9"  >
                        <Col sm="12" className='p-l-0 p-r-0' >
                            <Card className="pt-1 pl-3 pr-3  shadow-sm rounded" style={{ marginBottom: "20px" }} >
                                <Row>
                                    <Col sm="3">
                                        <Col sm="12" className="pr-0 pb-3" >
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/WorkOrderDay/AdmisionesCriticas.svg")}
                                                style={{ width: '60px' }}
                                                alt="Branch Icon"
                                                onClick={() => setFilterType("criticas")}
                                                className='pointers pointer'


                                            />
                                            <label className='text-center f-w-600 label-dashboard' style={{ fontSize: "16px", color: "#002940" }}>Criticas <b> {totalWorkOrderCritic ?? 0}</b></label>
                                        </Col>
                                    </Col>
                                    <Col sm="3">
                                        <Col sm="12" className="pr-0 pb-3">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/WorkOrderDay/AdmisionesUrgentes.svg")}
                                                style={{ width: '60px' }}
                                                alt="Branch Icon"
                                                onClick={() => setFilterType("urgentes")}
                                                className='pointer pointers'
                                            />
                                            <label className='text-center f-w-600 label-dashboard' style={{ fontSize: "16px", color: "#002940" }}>Urgentes <b> {totalWorkOrderUrgent ?? 0}</b></label>
                                        </Col>
                                    </Col>
                                    <Col sm="3">
                                        <Col sm="12" className="pr-0 pb-3">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/WorkOrderDay/AdmisionesNormales.svg")}
                                                style={{ width: '60px' }}
                                                alt="Branch Icon"
                                                onClick={() => setFilterType("normales")}
                                                className='pointer pointers'
                                            />
                                            <label className='text-center f-w-600 label-dashboard' style={{ fontSize: "16px", color: "#002940" }}>Normales <b> {totalWorkOrderNormal ?? 0}</b></label>
                                        </Col>
                                    </Col>
                                    <Col sm="3">
                                        <Col sm="12" className="pr-0 pb-3 p-l-0 p-r-0">
                                            <img
                                                src={require("../../../assets/images/loginHelenLabs/WorkOrderDay/AdmisionesTotales.svg")}
                                                style={{ width: '60px' }}
                                                alt="Branch Icon"
                                                onClick={() => setFilterType("totales")}
                                                className='pointer pointers'

                                            />
                                            <label className='text-center f-w-600 label-dashboard' style={{ fontSize: "14px", color: "#002940" }}>Total de admisiones <b> {totalWorkOrder ?? 0}</b></label>
                                        </Col>
                                    </Col>
                                </Row>


                            </Card>
                        </Col>

                        <Row className="pb-5 "  >
                            <Col sm="12" md="12" xl="12" className='pb-2' >
                                <div className="table-responsive">
                                    {
                                        workOrders.length === undefined
                                            ?
                                            <div style={{ textAlign: "-webkit-center" }}>
                                                <img className="img-fluid" src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "48%" }} alt="" />
                                                <br /> <p className='f-w-600 f-14 badge badge-light-primary' >No se ha registrado una Orden de Trabajo aún.</p>
                                            </div>
                                            :
                                            <div>
                                               
                                                <DataTable
                                                    // value={filteredWorkOrders}
                                                    value={workOrdersFiltered}
                                                    loading={loading || loadingToday}
                                                    dataKey="idWorkOrder"
                                                    responsiveLayout="scroll"
                                                    expandedRows={expandedRows2}
                                                    onRowToggle={(e) => setExpandedRows2(e.data)}
                                                    rowExpansionTemplate={rowExpansionTemplate2}
                                                    emptyMessage={
                                                        <div className="text-center">
                                                            <img
                                                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                                style={{ width: "45%" }}
                                                                alt="Sin resultados"
                                                            />
                                                            <br />
                                                            <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                                                                No hay coincidencias con la búsqueda.
                                                            </p>
                                                        </div>
                                                    }
                                                    sortField={sortField}
                                                    sortOrder={sortOrder}

                                                    onSort={(e) => {
                                                        setSortField(e.sortField);
                                                        setSortOrder(e.sortOrder);
                                                    }}
                                                    header={
                                                        <Col sm="12" className='p-l-0 p-r-0 ' >
                                                            <Row>
                                                                <Col sm="1" className='p-l-0 pt-2' >
                                                                    <button
                                                                        className="p-button p-button-success"
                                                                        onClick={() => exportToExcel(filteredWorkOrders)}
                                                                        title="Descargar reporte"
                                                                        style={{
                                                                            alignItems: "center",
                                                                            padding: "5px 8px",
                                                                            height: "35px",
                                                                            width: "35px",
                                                                            fontSize: "0.9rem",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            position: "relative"
                                                                        }}
                                                                    >
                                                                        <i className="pi pi-file-excel" style={{ fontSize: "1rem" }}></i>
                                                                    </button>
                                                                </Col>

                                                                <Col sm="11" className='p-r-0 pt-1' >
                                                                    <Col className={(_url_helen === cedimi || _url_helen === pyrsa || _url_helen === semlab || _url_helen === sharp) ? "d-none" : ""} sm="12 " >
                                                                        <Row>
                                                                            <Col sm="3" className='p-r-0 pt-2' style={{ textAlign: "end" }} >
                                                                                <Label className="col-form-label f-w-700">Ingresa el NIM  o Nombre</Label>
                                                                            </Col>
                                                                            <Col md="5" className='p-l-0 p-r-0 pt-2' >
                                                                                <FormGroup className="col-md-12">
                                                                                    <Input className='form-control form-control-sm input-air-primary' name="nim" value={nim} onChange={handleInputChange} />
                                                                                </FormGroup>
                                                                            </Col>

                                                                            <Col md="2" className='p-l-0 p-r-0 pt-2' >
                                                                                <SelectButton
                                                                                    value={match_exact}
                                                                                    options={OptionsCheck}
                                                                                    onChange={(e) => setMatchExact(e.value)}
                                                                                    unselectable={false}
                                                                                    className={`permission-toggle-sm permission`}
                                                                                    title='Define si la búsqueda debe de ser exacta o aproximada'
                                                                                />
                                                                            </Col>

                                                                            <Col md="2" className="d-flex justify-content-between">
                                                                                <FormGroup className="d-flex" style={{ gap: "8px" }}>
                                                                                    <Button
                                                                                        size="xs"
                                                                                        title='Buscar'
                                                                                        onClick={(e) => getWorkOrders(e, true)}
                                                                                        outline
                                                                                        color="primary"
                                                                                        className={(loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1")}
                                                                                    >
                                                                                        <i className="pi pi-search"></i>

                                                                                    </Button>

                                                                                    <Button
                                                                                        id='filterClear'
                                                                                        size="xs"
                                                                                        // title='Limpiar'
                                                                                        onClick={(e) => getWorkOrders(e, false, true, "Filtrar")}
                                                                                        outline
                                                                                        color="danger"
                                                                                        className={(loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1")}
                                                                                    >
                                                                                        <i className='pi pi-trash'></i>
                                                                                    </Button>
                                                                                    
                                                                                    <Tooltip
                                                                                        placement="top"
                                                                                        isOpen={tooltipOpen === "filterClear"}
                                                                                        target="filterClear"
                                                                                        toggle={() => toggleTooltip("filterClear")}
                                                                                    >
                                                                                        Restablecer filtros 
                                                                                    </Tooltip>

                                                                                </FormGroup>

                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col sm="12" className={(_url_helen === cedimi || _url_helen === pyrsa || _url_helen === semlab || _url_helen === sharp) ? "p-l-0 " : "d-none"} >
                                                                        <Row className="align-items-center">
                                                                                <Col
                                                                                    sm={
                                                                                        _url_helen === cedimi
                                                                                            ? (showDeliveryFilter ? "2" : "2")
                                                                                            : (showDeliveryFilter ? "2" : "5")
                                                                                    }
                                                                                    className="pt-1"
                                                                                >                                                                                
                                                                                {globalFilter2?.trim() && (
                                                                                    <div
                                                                                        style={{
                                                                                            color: "#856404",
                                                                                            fontSize: "0.78rem",
                                                                                            marginTop: "6px",
                                                                                            fontWeight: "500",
                                                                                            backgroundColor: "#fff3cd",
                                                                                            padding: "4px 10px",
                                                                                            borderRadius: "6px",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            gap: "6px",
                                                                                            border: "1px solid #ffeeba",
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-exclamation-triangle" />
                                                                                        Filtro activo de búsqueda
                                                                                    </div>
                                                                                )}
                                                                            </Col>
                                                                           <Col
                                                                                sm={_url_helen === cedimi ? "1" : (showDeliveryFilter ? "1" : "2")}
                                                                                className="text-right"
                                                                            >
                                                                                <Label className="col-form-label f-w-700 mb-0">
                                                                                    Búsqueda
                                                                                </Label>
                                                                            </Col>

                                                                            <Col sm={showDeliveryFilter ? "4" : "5"}>
                                                                            
                                                                                <InputText
                                                                                    type="search"
                                                                                    className="w-100"
                                                                                    onInput={(e) => setGlobalFilter2(e.target.value)}
                                                                                    value={globalFilter2}
                                                                                />
                                                                            </Col>

                                                                            {(_url_helen === cedimi || _url_helen === semlab) && (
                                                                                <Col   olfczsm={showDeliveryFilter ? "2" : "4"} className="d-flex justify-content-end align-items-center">
                                                                                    <button
                                                                                        id="btnCompromisosHoy"
                                                                                        type="button"
                                                                                        className="btn shadow-sm me-2 mr-1"
                                                                                        onClick={() => {
                                                                                            setShowDeliveryFilter(true);
                                                                                            getStudyDeliveryToday();
                                                                                        }}
                                                                                        disabled={loadingToday}
                                                                                        style={{
                                                                                            width: "120px",
                                                                                            background: "linear-gradient(135deg,#1547a3,#2399ff)",
                                                                                            color: "#fff",
                                                                                            border: "none",
                                                                                            borderRadius: "14px",
                                                                                            height: "43px",
                                                                                            fontWeight: "600",
                                                                                            transition: "all .2s ease",
                                                                                            opacity: loadingToday ? 0.8 : 1,
                                                                                            cursor: loadingToday ? "not-allowed" : "pointer"
                                                                                        }}
                                                                                    >
                                                                                        {loadingToday ? (
                                                                                            <>
                                                                                                <span
                                                                                                    className="spinner-border spinner-border-sm mr-2"
                                                                                                    role="status"
                                                                                                    aria-hidden="true"
                                                                                                />
                                                                                                ...
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <i className="fa fa-calendar-check-o mr-2"></i>
                                                                                                Hoy
                                                                                            </>
                                                                                        )}
                                                                                    </button>

                                                                                    <Tooltip
                                                                                        placement="top"
                                                                                        isOpen={tooltipOpen === "btnCompromisosHoy"}
                                                                                        target="btnCompromisosHoy"
                                                                                        toggle={() => toggleTooltip("btnCompromisosHoy")}
                                                                                    >
                                                                                        Ver NIMs comprometidos para entregar hoy
                                                                                    </Tooltip>

                                                                            
                                                                                </Col>
                                                                       )}


                                                                                {showDeliveryFilter && (
                                                                                <Col
                                                                                        sm={showDeliveryFilter ? "3" : "4"}
                                                                                        className="d-flex justify-content-end align-items-center"
                                                                                    >
                                                                                    <Dropdown
                                                                                        value={deliveryStatusFilter}
                                                                                        options={statusOptions}
                                                                                        optionLabel="label"
                                                                                        optionValue="value"
                                                                                        placeholder="Estado entrega"
                                                                                        showClear

                                                                                        className="w-100 mr-1"
                                                                                        onChange={(e) => setDeliveryStatusFilter(e.value)}
                                                                                    />

                                                                                    <button
                                                                                        id="filterClear"
                                                                                        size="xs"
                                                                                         onClick={(e) => {
                                                                                            setShowDeliveryFilter(false);
                                                                                            setDeliveryStatusFilter(null);
                                                                                            getWorkOrders(e, false, true, "Filtrar");
                                                                                        }}
                                                                                        className={(loading ? "disabled progress-bar-animated progress-bar-striped mt-1 text-center" : "text-center mt-1")}
                                                                                        style={{
                                                                                            width: "40px",
                                                                                            background: "linear-gradient(135deg,#a51010,#ed0b0b)",
                                                                                            color: "#fff",
                                                                                            border: "none",
                                                                                            borderRadius: "14px",
                                                                                            height: "43px",
                                                                                            fontWeight: "600",
                                                                                            transition: "all .2s ease",
                                                                                            opacity: loadingToday ? 0.8 : 1,
                                                                                            cursor: loadingToday ? "not-allowed" : "pointer"
                                                                                        }}
                                                                                    >
                                                                                        <i className="pi pi-trash"></i>
                                                                                    </button>
                                                                                </Col>
                                                                            )}

                                                                            
                                                                          
                                                                        </Row>
                                                                    </Col>
                                                                </Col>

                                                                {/* <Col sm="2" className="pt-1">
                                                                   
                                                                    <button
                                                                        id="btnCompromisosHoy"
                                                                        type="button"
                                                                        className="btn w-100 shadow-sm"
                                                                        onClick={getStudyDeliveryToday}
                                                                        disabled={loadingToday}
                                                                        style={{
                                                                            background: "linear-gradient(135deg,#1547a3,#2399ff)",
                                                                            color: "#fff",
                                                                            border: "none",
                                                                            borderRadius: "14px",
                                                                            height: "43px",
                                                                            fontWeight: "600",
                                                                            transition: "all .2s ease",
                                                                            opacity: loadingToday ? 0.8 : 1,
                                                                            cursor: loadingToday ? "not-allowed" : "pointer"
                                                                        }}
                                                                    >
                                                                         {loadingToday ? (
                                                                            <>
                                                                                <span
                                                                                    className="spinner-border spinner-border-sm mr-2"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                />
                                                                                Cargando...
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <i className="fa fa-calendar-check-o mr-2"></i>
                                                                                Hoy
                                                                            </>
                                                                        )}
                                                                    </button>

                                                                    <Tooltip
                                                                        placement="top"
                                                                        isOpen={tooltipOpen === "btnCompromisosHoy"}
                                                                        target="btnCompromisosHoy"
                                                                        toggle={() => toggleTooltip("btnCompromisosHoy")}
                                                                    >
                                                                        Ver NIMs comprometidos para entregar hoy
                                                                    </Tooltip>
                                                                </Col> */}
                                                            </Row>
                                                        </Col>
                                                         
                                                    }
                                                >

                                                    <Column header="#" body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} sortable field="id_work_order" />
                                                    <Column
                                                        header="NIM"
                                                        sortable
                                                        field="nim"
                                                        headerStyle={headerStyle}
                                                        style={centerStyle}
                                                        body={(row) => {
                                                            const status = getLedStatus(row);

                                                            const color =
                                                                status === "green"
                                                                    ? "#2ecc71"
                                                                    : status === "yellow"
                                                                        ? "#f1c40f"
                                                                        : "#e74c3c";

                                                            return (
                                                                <div
                                                                    style={{
                                                                        position: "relative",
                                                                        display: "inline-block",
                                                                        width: "100%"
                                                                    }}
                                                                >
                                                                    {tagInfo(row)}

                                                                    {_validTraceability && (
                                                                        <i
                                                                            className="pi pi-circle-fill"
                                                                            onClick={(e) =>
                                                                                handleShowTraceability(e, row.id_work_order, row.nim)
                                                                            }
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "-4px",
                                                                                right: _menu === "True" ? "-4px" : "-3px",
                                                                                color,
                                                                                fontSize: "0.75rem",
                                                                                textShadow: `0 0 6px ${color}80`,
                                                                                cursor: "pointer"
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                            );
                                                        }}
                                                    />

                                                    <Column header="F.admisión" field="admision_date" sortable sortFunction={sortByDateTime} body={(row) => getDate(row)} headerStyle={headerStyle} style={centerStyle} />
                                                    {showStudyDelivery && (
                                                        <Column
                                                            field="study_delivery"
                                                            header="Fecha de entrega"
                                                          
                                                            headerStyle={headerStyle}
                                                            style={centerStyle}
                                                            body={(row) => {

                                                                if (!row.study_delivery) return "---";

                                                                const deliveredStatus = [8, 9, 13, 15, 18, 21];

                                                                const now = new Date();
                                                                const delivery = new Date(row.study_delivery);

                                                                const diffMinutes = (delivery - now) / 60000;

                                                                let color = "#0d6dfd";
                                                                let background = "#e7f1ff";
                                                                let status = "En tiempo";

                                                                if (deliveredStatus.includes(row.id_status)) {
                                                                    color = "#28a745";
                                                                    background = "#eaf7ee";
                                                                    status = "Entregado";
                                                                }
                                                                else if (diffMinutes <= 0) {
                                                                    color = "#dc3545";
                                                                    background = "#fdecec";
                                                                    status = "Vencido";
                                                                }
                                                                else if (diffMinutes <= 60) {
                                                                    color = "#fd7e14";
                                                                    background = "#fff3e8";
                                                                    status = "Urgente";
                                                                }
                                                                else if (diffMinutes <= 120) {
                                                                    color = "#ffcc07";
                                                                    background = "#fff8db";
                                                                    status = "Próxima";
                                                                }

                                                                return (
                                                                    <div
                                                                        style={{
                                                                            borderLeft: `5px solid ${color}`,
                                                                            background,
                                                                            borderRadius: "6px",
                                                                            padding: "6px 8px",
                                                                            minWidth: "170px",
                                                                            textAlign: "left"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                color,
                                                                                fontWeight: 700,
                                                                                fontSize: "12px",
                                                                                textTransform: "uppercase",
                                                                                marginBottom: "2px"
                                                                            }}
                                                                        >
                                                                            {status}
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                color: "#495057",
                                                                                fontSize: "13px",
                                                                                fontWeight: 600
                                                                            }}
                                                                        >
                                                                            {moment(row.study_delivery).format("DD/MM/YYYY")}
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                color: "#1f2021",
                                                                                fontSize: "12px",
                                                                                fontWeight: 500
                                                                                
                                                                            }}
                                                                        >
                                                                            {moment(row.study_delivery).format("hh:mm a")}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                
                                                    <Column header="Sección/Área" body={(row) => getSection(row)} headerStyle={headerStyle} style={centerStyle} field="is_micro" />
                                                    {
                                                        _url_helen === labcen && <Column
                                                            header="Muestras"
                                                            headerStyle={{ ...headerStyle, textAlign: "center" }}
                                                            style={{ ...cellStyle, textAlign: "center", width: "50px", paddingBottom: 0, }}
                                                            body={(rowData) => (
                                                                <div
                                                                    className="d-flex justify-content-center"
                                                                    style={{ gap: "4px", alignItems: "flex-start" }}
                                                                >

                                                                    <button
                                                                        onClick={() => handleViewExamTree(rowData?.nim)}
                                                                        title="Visualizar Orden"
                                                                        style={buttonStyle8}
                                                                        className={rowData?.id_status === 20 ? "d-none" : ""}
                                                                        color='success'
                                                                    >
                                                                        <i style={{ fontSize: "14px" }} className="icofont icofont-laboratory"></i>
                                                                    </button>


                                                                </div>
                                                            )}
                                                        />
                                                    }

                                                    <Column header="Paciente" body={(row) => getPatient(row)} headerStyle={headerStyle} style={centerStyle} field="id_work_order" />
                                                    <Column field="name_branch" sortable header="Sucursal" headerStyle={headerStyle} style={centerStyle} />
                                                    <Column header="Tipo de ingreso" sortable body={(row) => getNameCompany(row)} headerStyle={headerStyle} style={centerStyle} field="income_type" />
                                                    <Column
                                                        header="Estatus"
                                                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                                                        className="text-center"
                                                        body={(rowData) => (
                                                            <div className="d-flex justify-content-center w-100">
                                                                {renderStatusTag(rowData)}
                                                            </div>
                                                        )}
                                                        style={{
                                                            alignItems: "flex-start"
                                                        }}
                                                        sortable
                                                        field="id_status"
                                                    />




                                                    <Column
                                                        header="Acciones"
                                                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                                                        style={{ ...cellStyle, textAlign: "center", width: "250px", paddingBottom: 0, }}
                                                        body={(rowData) => (
                                                            <div
                                                                className="d-flex justify-content-center"
                                                                style={{ gap: "4px", alignItems: "flex-start" }}
                                                            >
                                                                {
                                                                    rowData?.id_status === 20 && <Tag style={{ fontSize: "11px" }} className="mr-2 pt-1" severity='danger' value="Cancelado" ></Tag>
                                                                }
                                                                <button
                                                                    onClick={() => navigateUpdate(rowData?.id_work_order)}
                                                                    title="Editar Orden"
                                                                    style={buttonStyle}
                                                                    className={rowData?.id_status === 20 ? "d-none" : ""}
                                                                >
                                                                    <i style={{ fontSize: "14px" }} className="fa fa-edit"></i>
                                                                </button>

                                                                <button
                                                                    onClick={() => printTicket(rowData?.id_work_order)}
                                                                    title="Reimprimir Ticket"
                                                                    style={buttonStyle6}
                                                                    className={rowData?.id_status === 20 ? "d-none" : ""}

                                                                >
                                                                    <i style={{ fontSize: "14px" }} className="fa fa-ticket"></i>
                                                                </button>

                                                                <button
                                                                    onClick={rowData.is_micro == true ? () => printStickerMicro(rowData.id_work_order) : () => printSticker(rowData.id_work_order)}
                                                                    title="Etiquetas"
                                                                    style={buttonStyle5}
                                                                    className={rowData?.id_status === 20 ? "d-none" : ""}

                                                                >
                                                                    <i style={{ fontSize: "14px" }} className="fa fa-barcode"></i>
                                                                </button>

                                                                <button
                                                                    onClick={() => navigateConfigPrices(rowData?.id_work_order)}
                                                                    title="Detalle de impresión"
                                                                    style={buttonStyle7}
                                                                    className={rowData?.id_status === 20 ? "d-none" : ""}
                                                                >
                                                                    <i style={{ fontSize: "14px" }} className="fa fa-clipboard"></i>
                                                                </button>
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>
                                                {
                                                    // ? OVERLAY PANEL DE TRAZABILIDAD
                                                }
                                                <OverlayPanel
                                                    ref={opTraceability}
                                                    style={{ width: "520px" }}
                                                    showCloseIcon
                                                >
                                                    {loadingTrazability ? (
                                                        <div className="text-center p-3">
                                                            <i className="pi pi-spin pi-spinner mr-2" />
                                                            Cargando trazabilidad...
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div className="traceability-ribbon">
                                                                NIM: {selectedNim}
                                                            </div>

                                                            <div className="traceability-container" style={{
                                                                maxHeight: "200px",
                                                                overflowY: "auto"
                                                            }}>
                                                                {dataTraceability.map((row, index) => (
                                                                    <div className="traceability-card pt-0 pb-0" key={index}>
                                                                        <div className="traceability-study-name">
                                                                            {row.type === "profile"
                                                                                ? row.profile_name
                                                                                : row.name}
                                                                        </div>

                                                                        <div className="traceability-status-group">
                                                                            <div className="traceability-status-item">
                                                                                <span>Toma</span>
                                                                                {getTraceabilityStatus(row, "is_toma") ? (
                                                                                    <i className="pi pi-check-circle traceability-success" />
                                                                                ) : (
                                                                                    <i className="pi pi-times-circle traceability-danger" />
                                                                                )}
                                                                            </div>

                                                                            <div className="traceability-status-item">
                                                                                <span>Envío</span>
                                                                                {getTraceabilityStatus(row, "is_send1") ? (
                                                                                    <i className="pi pi-check-circle traceability-success" />
                                                                                ) : (
                                                                                    <i className="pi pi-times-circle traceability-danger" />
                                                                                )}
                                                                            </div>

                                                                            <div className="traceability-status-item">
                                                                                <span>Recepción</span>
                                                                                {getTraceabilityStatus(row, "is_send2") ? (
                                                                                    <i className="pi pi-check-circle traceability-success" />
                                                                                ) : (
                                                                                    <i className="pi pi-times-circle traceability-danger" />
                                                                                )}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )}
                                                </OverlayPanel>
                                            </div>
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row> <br />
            </div>

            <Dialog
                className="pt-0 custom-dialog-bussine"
                header="Muestras"
                visible={modalCheckSpecimen}
                style={{ width: '60vw', maxWidth: '700px' }}
                modal
                dismissableMask
                onHide={toggleListExamEmail}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                    content: { style: { paddingLeft: "1px" } }
                }}
                footer={
                    <Button size="sm" outline color="danger" type="button" onClick={toggleListExamEmail}   >
                        Cancelar
                    </Button>
                }

            >

                <>

                    <Col sm="12">
                        {
                            loadingSpecimen ?
                                <div style={{ textAlign: "-webkit-center" }}>
                                    <img alt='modal-preview' src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='fa-spin' style={{ width: "8%" }} />
                                    <br /> <p className='f-w-600 f-14 badge badge-light-primary' >Cargando muestras...</p>
                                </div>
                                :
                                <Row>
                                    <Col sm="12"> <br />
                                        <DeniReactTreeView
                                            className="deni-react-treeview-container5"
                                            ref={treeviewRef}
                                            style={{ marginRight: '10px', marginBottom: '10px', textAlign: "center" }}
                                            showCheckbox={false}
                                            showIcon={false}
                                            items={itemsTree}
                                            onRenderItem={onRenderItem}
                                            selectRow={false}
                                        />
                                    </Col>
                                </Row>
                        }

                    </Col>
                </>

            </Dialog>





        </Fragment >
    )
}